/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Confirm_ApproveInputs */



/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Assistant_Confirm_ApproveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_confirm_approve = /** @type {((inputs?: Assistant_Confirm_ApproveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Confirm_ApproveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approuver")
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approvare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Утвердить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批准")
	if (locale === "ja") return /** @type {LocalizedString} */ ("承認する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मंज़ूरी देना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovar")
	return /** @type {LocalizedString} */ ("Approve")
});